// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Root from './App'
import router from './router'
import global_ from './components/utils/Global'
import SiteHeader from './components/SiteHeader'
import SiteFooter from './components/SiteFooter'

import remoteApi from './components/remote/api'
import store from "./store"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.Global = global_
Vue.prototype.$dataApi = remoteApi

Vue.component('site-header', SiteHeader)
Vue.component('site-footer', SiteFooter)
router.beforeEach((to,from,next)=>{
  if(to.meta&&to.meta.type==1) {
    store.dispatch("changeHideHeaderFooterDispatch",true)
  } else {
    store.dispatch("changeHideHeaderFooterDispatch",false)
  }
  console.log('设置',store.state.hideHeaderFooter)
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#root-content',
  router,
  store,
  components: { Root },
  template: '<Root/>',
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});



// WEBPACK FOOTER //
// ./src/main.js